import gql from 'graphql-tag';

export default gql`
  fragment manualMailActionFragment on ManualMailAction {
    id
  }
`;
